import { gql } from '@apollo/client'

export const POLL_ASYNC_JOBS = gql`
  query PollAsyncJobs($ids: [String!]) {
    asyncTasks(ids: $ids) {
      id
      status
      result
    }
  }
`
